import { useState } from 'react';
import { Card } from '@packages/shared/src/ui/Card/Card';
import { Divider } from '@packages/shared/src/ui/Divider/Divider';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { defineMessages, FormattedNumber, useIntl } from 'react-intl';
import { Notification } from '@packages/shared/src/ui/Notification/Notification';

const messages = defineMessages({
  paybackBoxHeader: {
    defaultMessage: 'Mein PAYBACK °Punktestand',
    id: 'PaybackBoxV2.Headline',
  },
  paybackBoxLink: {
    defaultMessage: 'Zu allen PAYBACK Transaktionen',
    id: 'PaybackBoxV2.Login.Link',
  },
  paybackCardNumber: {
    defaultMessage: 'Kartennummer: {cardNumber}',
    id: 'PaybackBoxV2.CardNumber',
  },
});
export type PaybackBoxV2Props = {
  loyaltyProgramData: { cardNumber: string | null; basePoints: number | null };
  warningMessage?: string;
};
export const PaybackBoxV2: React.FC<PaybackBoxV2Props> = ({
  loyaltyProgramData: { basePoints, cardNumber },
  warningMessage,
}) => {
  const {
    order: {
      payback: { links: paybackLinks },
    },
  } = useConfig();
  const [showInlineNotification, setShowInlineNotification] = useState<boolean>(!!warningMessage);
  const { formatMessage } = useIntl();
  return (
    <Card className="border-color-payback-dark font-family-payback flex w-full flex-col gap-1 border bg-[#cce6ff] p-1.5">
      <h5 className="leading-snug font-bold">{formatMessage(messages.paybackBoxHeader)}</h5>
      {basePoints && basePoints >= 0 && (
        /*! connected && */
        <div className="flex items-center gap-1">
          <span className="icon-emp-payback-colored h-3.5 w-3.5" />
          <p className="text-size-h2 text-color-payback-dark">
            <FormattedNumber value={basePoints} /> °P
          </p>
        </div>
      )}
      {showInlineNotification && (
        <Notification onClose={() => setShowInlineNotification(false)} severity="warning">
          {warningMessage}
        </Notification>
      )}
      <Divider className="h-auto" />
      {cardNumber && (
        <p className="text-color-payback-dark text-size-body2 font-bold">
          {formatMessage(messages.paybackCardNumber, { cardNumber })}
        </p>
      )}
      <a
        className="font-inherit text-inherit"
        href={paybackLinks?.partner ?? ''}
        target="_blank"
        rel="noreferrer"
      >
        <p className="text-color-text-dark text-size-body2">
          {formatMessage(messages.paybackBoxLink)}
        </p>
      </a>
    </Card>
  );
};
